<template>
  <at-badge v-if="rejectCase.is_full" color="red" rounded>
    {{ $t('entities.rejectCase.rejectionType.full') }}
  </at-badge>
  <at-badge v-else color="yellow" rounded>
    {{ $t('entities.rejectCase.rejectionType.partial') }}
  </at-badge>
</template>

<script setup>
  import { AtBadge } from '@packages/aliftech-ui';

  defineProps({
    rejectCase: {
      type: Object,
      required: true,
    },
  });
</script>
